// extracted by mini-css-extract-plugin
export var chevron = "_ft-2";
export var dropdownItems = "_ft-0";
export var item = "_ft-1";